<section class="statistics-v2">
  <div class="inner">
    <div class="first-part">
      <h2>
        <span class="line-container">
          <span data-aos="fade-in" data-aos-delay="200"> we </span>
          <span class="line" data-aos="fade-in" data-aos-delay="225"></span>
        </span>
        <span data-aos="fade-in" data-aos-delay="250"> redefine </span>
        <span data-aos="fade-in" data-aos-delay="300"> your </span>
        <span data-aos="fade-in" data-aos-delay="350"> marine </span>
        <span data-aos="fade-in" data-aos-delay="400"> procurement process </span>
      </h2>
      <a
        data-aos="fade-in"
        data-aos-delay="200"
        class="landing-v2-button"
        href="contact-us"
        style="height: 120px;
        width: 155px;"
      >
        <span class="icon">
          <svg
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.927659"
              y1="25.8056"
              x2="25.0061"
              y2="1.72716"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="6.25293"
              y1="1.43408"
              x2="25.7132"
              y2="1.43408"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="24.7129"
              y1="22.0596"
              x2="24.7129"
              y2="2.43399"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </span>
        <span> more about us </span>
      </a>
    </div>
    <div class="statistics-grid">
      <div class="statistics-item">
        <span data-aos="fade-in" data-aos-delay="250" class="number"
          >4.5k+</span
        >
        <span data-aos="fade-in" data-aos-delay="300" class="text"
          >Purchase Order</span
        >
      </div>
      <div class="statistics-item">
        <span data-aos="fade-in" data-aos-delay="300" class="number">500+</span>
        <span data-aos="fade-in" data-aos-delay="350" class="text"
          >Served Vessels</span
        >
      </div>
      <div class="statistics-item">
        <span data-aos="fade-in" data-aos-delay="350" class="number">15</span>
        <span data-aos="fade-in" data-aos-delay="400" class="text"
          >Ports Covered</span
        >
      </div>
      <div class="statistics-item">
        <span data-aos="fade-in" data-aos-delay="400" class="number"
          >2.5m+</span
        >
        <span data-aos="fade-in" data-aos-delay="450" class="text"
          >Items Delivered</span
        >
      </div>
    </div>
    <a
      data-aos="fade-in"
      data-aos-delay="200"
      class="landing-v2-button"
      href="contact-us"
    >
      <span class="icon">
        <svg
          width="26"
          height="27"
          viewBox="0 0 26 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="0.927659"
            y1="25.8056"
            x2="25.0061"
            y2="1.72716"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="6.25293"
            y1="1.43408"
            x2="25.7132"
            y2="1.43408"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="24.7129"
            y1="22.0596"
            x2="24.7129"
            y2="2.43399"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </span>
      <span> more about us </span>
    </a>
  </div>
</section>
